import { Customer } from 'lib/context';

export type InitialValuesType = {
  [key: string]: string | number | null;
};

export type ConvertedValuesType = {
  [key: string]: string[] | string | number;
};

export enum IMS_PROVIDERS_LABELS {
  VAUTO = 'VAuto',
  EDEALER = 'Edealer',
  HOMENET = 'Homenet',
  MAX_DIGITAL = 'MaxDigital',
  DEALERS_LINK = 'DealersLink',
  DEALER_CUE = 'DealerCue',
  AUTO_REVOLUTION = 'AutoRevolution',
  VINSOLUTIONS = 'Vinsolutions',
  DEALER_CENTER = 'DealerCenter',
  DEALR_CLOUD = 'DealrCloud',
  VIN_MOTION = 'VinMotion',
  AUTO_SWEET = 'AutoSweet',
  DEALERSOCKET = 'DealerSocket',
  PREDIAN = 'Predian',
  DEALER_INSPIRE = 'DealerInspire',
  CARS_FOR_SALE = 'CarsForSale',
  DEALER_CAR_SEARCH = 'DealerCarSearch',
  INVENTORY_PLUS = 'InventoryPlus',
  PRO_MAX = 'ProMax',
  JD_POWER = 'JDPower',
  AUTOVERIFY = 'AutoVerify',
  DEALER_DOT_COM = 'Dealer.com',
  ASTRAWEBIDS = 'AstraWebIDS',
  AGENCY360 = '360.Agency',
  SINCRO = 'Sincro',
  DEALER_SYNC = 'DealerSync',
  DAELER_E_PROCESS = 'DealerEProcess',
  CDK = 'CDK',
  DEAL_PACK = 'DealPack',
  CARPRAZE = 'Carpraze',
  AUTOTRADER = 'AutoTrader',
  NET_LOOK = 'NetLook',
  AUTO_VISION = 'AutoVision',
  DEALER_MEDIA_SOLUTIONS = 'DelerMediaSolutions',
  D2C_MEDIA = 'D2CMedia',
  PRO_MOTION_PIX = 'ProMotionPix',
}

export enum IMS_PROVIDERS_VALUES {
  VAUTO = 'vAutoDealerId',
  EDEALER = 'eDealerId',
  HOMENET = 'homeNetId',
  MAX_DIGITAL = 'maxDigitalId',
  DEALERS_LINK = 'dealersLinkId',
  DEALER_CUE = 'dealerCueId',
  AUTO_REVOLUTION = 'autoRevolutionId',
  VINSOLUTIONS = 'vinsolutionsIMSDealerId',
  DEALER_CENTER = 'dealerCenterDealerId',
  DEALR_CLOUD = 'dealrCloudId',
  VIN_MOTION = 'vinMotionId',
  AUTO_SWEET = 'autoSweetId',
  DEALERSOCKET = 'dealerSocketIMSDealerId',
  PREDIAN = 'predianId',
  DEALER_INSPIRE = 'dealerInspireId',
  CARS_FOR_SALE = 'carsForSaleId',
  DEALER_CAR_SEARCH = 'dealerCarSearchId',
  INVENTORY_PLUS = 'inventoryPlusId',
  PRO_MAX = 'proMaxId',
  JD_POWER = 'jdPowerId',
  AUTOVERIFY = 'autoVerifyDealerId',
  DEALER_DOT_COM = 'dealerDotComIMS',
  ASTRAWEBIDS = 'astraWebIDSId',
  AGENCY360 = 'agency360Id',
  SINCRO = 'sincroId',
  DEALER_SYNC = 'dealerSyncId',
  DAELER_E_PROCESS = 'dealerEProcessId',
  CDK = 'cdkStoreId',
  DEAL_PACK = 'dealPackDealerId',
  CARPRAZE = 'carprazeId',
  AUTOTRADER = 'autoTraderId',
  NET_LOOK = 'netLookId',
  AUTO_VISION = 'autoVisionID',
  DEALER_MEDIA_SOLUTIONS = 'dealerMediaSolutionsId',
  D2C_MEDIA = 'd2cMediaId',
  PRO_MOTION_PIX = 'proMotionPixId',
}

export type IMSFields = {
  vAutoDealerId: string | null;
  vinMotionId: string | null;
  autoSweetId: string | null;
  eDealerId: string | null;
  homeNetId: string | null;
  maxDigitalId: string | null;
  dealersLinkId: string | null;
  dealerCueId: string | null;
  autoRevolutionId: string | null;
  vinsolutionsIMSDealerId: string | null;
  dealerSocketIMSDealerId: string | null;
  dealerCenterDealerId: string | null;
  dealrCloudId: string | null;
  predianId: string | null;
  dealerInspireId: string | null;
  carsForSaleId: string | null;
  dealerCarSearchId: string | null;
  inventoryPlusId: string | null;
  proMaxId: string | null;
  jdPowerId: string | null;
  autoVerifyDealerId: string | null;
  dealerDotComIMS: string | null;
  astraWebIDSId: string | null;
  agency360Id: string | null;
  sincroId: string | null;
  dealerSyncId: string | null;
  dealerEProcessId: string | null;
  cdkStoreId: string | null;
  dealPackDealerId: string | null;
  carprazeId: string | null;
  autoTraderId: string | null;
  netLookId: string | null;
  autoVisionID: string | null;
  dealerMediaSolutionsId: string | null;
  d2cMediaId: string | null;
  proMotionPixId: string | null;
};

export type IIMSConnection = IMSFields & {
  customerId: number;
  business: string;
  hideInventoryItemPrice: number;
};

export interface IMSConnectedResponse {
  customers: Customer[];
  count: number;
}

export type IMSProviderOption = {
  value: IMS_PROVIDERS_VALUES;
  label: IMS_PROVIDERS_LABELS;
};
